export default __webpack_public_path__ + "static/media/building-left.fe41bae1.svg";